import general from "./general.json";
import menu from "./menu.json";
import translation from "./translation.json";
import button from "./button.json";
import colors from "./colors.json";
import formField from "./form-field.json";
import icon from "./icon.json";
import tables from "./tables.json";
import typography from "./typography.json";
import freezerModel from "./freezer-model.json";
import fuelType from "./fuel-type.json";
import historyPanel from "./history-panel.json";
import vehicleAuxiliary from "./vehicle-auxiliary.json";
import vehicleModel from "./vehicle-model.json";
import vehicleType from "./vehicle-type.json";
import tripType from "./trip-type.json";
import distanceType from "./distance-type.json";
import driverAllowance from "./driver-allowance.json";
import tripDaysThreshold from "./trip-days-threshold.json";
import vehicleOperation from "./vehicle-operation.json";
import waitingTimeRate from "./waiting-time-rate.json";
import driverTripCalculator from "./driver-trip-calculator.json";
import historyDataSidebar from "./history-data-sidebar.json";
import login from "./login.json";
import vendor from "./vendor.json";
import fleet from "./fleet.json";
import driver from "./driver.json";
import customer from "./customer.json";
import loa from "./loa.json";

export const id = {
  button,
  colors,
  distanceType,
  driver,
  driverAllowance,
  driverTripCalculator,
  formField,
  freezerModel,
  fuelType,
  general,
  historyDataSidebar,
  historyPanel,
  icon,
  login,
  menu,
  tables,
  translation,
  tripDaysThreshold,
  tripType,
  vendor,
  fleet,
  typography,
  vehicleAuxiliary,
  vehicleModel,
  vehicleOperation,
  vehicleType,
  waitingTimeRate,
  loa,
  customer
} as const;

export default id;
